
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import api, { setAuthToken } from "../../api/baseUrl";
import { useUser } from "../../context/UserContext";

import PrimaryButton from "../Button/primaryButton/PrimaryButton";
import Snackbar from "../SnackBar/SnackBar";
import "./loginFrom.css";

export default function LoginForm() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  // پیام و نوع اسنک‌بار
  const [snackbar, setSnackbar] = useState({
    title: "",
    description: "",
    type: "info",
  });
console.log(api)
  const { setAdminName ,setUserRole  } = useUser();
  const navigate = useNavigate();

  // ---- Login Handler ----
  const handleLogin = async (e) => {
    e.preventDefault();

    if (!username.trim() || !password) {
      setSnackbar({
        title: "خطا در ورود",
        description: "لطفاً نام کاربری و رمز عبور را وارد کنید",
        type: "error",
      });
      return;
    }

    setLoading(true);

  try {
  const response = await api.post("/login", { username, password });
const { token, name, role } = response.data;

  setAuthToken(token);
  setAdminName(name);
  setUserRole(role); // 👈 نقش را در context ذخیره کن


  // نمایش سریع Snackbar
  setSnackbar({
    title: "ورود موفقیت‌آمیز بود!",
    description: `خوش آمدی ${name} `,
    type: "success",
  });

  // هدایت سریع‌تر (بعد از 0.8 ثانیه)
  setTimeout(() => {
    if (role === "manager") navigate("/admin");
    else if (role === "bowner") navigate("/admin");
    else if (role === "marketer") navigate("/visitor");

    else navigate("/");
  }, 800);

} catch (err) {
  console.error("Login Error:", err.response?.data || err.message);
  setSnackbar({
    title: "خطا در ورود!",
    description: "نام کاربری یا رمز عبور اشتباه است",
    type: "error",
  });
} finally {
  setLoading(false);
}

  };

  return (
    <div className="container">
      <div className="login-section" id="step1">
        <h2>ورود به حساب کاربری</h2>
        <form onSubmit={handleLogin} className="modal-form">
          <div className="form__input-group">
            <input
              id="username"
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder=" "
              required
              className="form__input"
            />
            <label htmlFor="username" className="form__input-label">
              نام کاربری
            </label>
          </div>

          <div className="form__input-group">
            <input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder=" "
              required
              className="form__input"
            />
            <label htmlFor="password" className="form__input-label">
              رمز عبور
            </label>
          </div>

          <PrimaryButton title="ورود" type="submit" loading={loading} fullWidth />
        </form>

        {/* Snackbar */}
        {snackbar.title && (
          <Snackbar
            title={snackbar.title}
            description={snackbar.description}
            type={snackbar.type}
            duration={2000}
            onClose={() => setSnackbar({ title: "", description: "", type: "info" })}
          />
        )}
      </div>
    </div>
  );
}
